import React from 'react';
import {Image, PageHeader} from 'antd';

const Table = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Таблица"
            />
            <h3>Таблица - основной режим для просмотра и редактирования данных</h3><br/>
            <Image
                width={800}
                src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601226927/documentation/Screenshot_2020-09-27_at_20.15.12_svch2j.png"
            /><br/><br/>
            <p>В режиме таблицы пользователь может просматривать подробные данные обо всех событиях по соответствующей строке кнопке more,<br/>
            выезжает task page drawer со всей доступной информацией о событии.<br/>
            В выпадающем списке Columns пользователь может скрывать нужные ему колонки<br/>
            При клике по шапке таблицы в соответствующие колонки фильтруются<br/>
            Для администратора доступна кнопка Add new task, по которой открывается форма заполнения события (подробнее - в разделе Формы)<br/>
            <h4>Режим инлайн-редактирования</h4><br/>
                    <Image
                        width={800}
                        src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601227027/documentation/Screenshot_2020-09-27_at_20.16.58_xcnfma.png"
                    /><br/><br/>
            В режиме администратора так же доступна колонка Action, по кнопке edit или по двойному клику на строку таблицы,<br/>
            включается режим инлайнового редактирования, все поля кроме duration являются обязательными для заполнения<br/>
            Для установки даты используется date picker antd<br/>
                    <Image
                        width={400}
                        src="https://res.cloudinary.com/dv4fxot90/image/upload/v1601227164/documentation/Screenshot_2020-09-27_at_20.18.34_uvlvaf.png"
                    /><br/><br/>
            Для установки времени используется time picker antd<br/>
            Далее все поля заполняются с клавиатуры, чтобы добавить несколько ссылок напишите их через запятую<br/>
            Чтобы редактировать больше информации используется task page drawer, кнопка more => иконка в виде карандашика в drawere (подробнее - в разделе Формы)
            </p>
        </>
    );
};

export default Table;